import { CTABannerRefProjection } from '../references/CTABannerRef.query';
import { taxonomiesProjection } from '../components/Atoms/TaxonomiesById.query';

export const queryVideo = groq`
  *[
    _type == "video" && currentPathname == $currentPathname
  ][0] {
    ...,
    ${taxonomiesProjection},
    person[]{
      reference->,
    },
    CTABanner{
      reference-> ${CTABannerRefProjection}
    },
  }
`;
